import { useCallback, useEffect } from "react";
import { AccessibilityCheckerTab } from "../components/tabs/accessibility-checker-tab";
import { createFileRoute } from "@tanstack/react-router";
import { useConfigStore } from "@/stores/widget-store";
import { useToast } from "@/hooks/use-toast";
import CheckerSkeletonLoader from "@/components/checker-skeleton-loader";

export const Route = createFileRoute("/")({
  component: AccessibilityChecker,
});

function AccessibilityChecker() {
  const { isLoading, fetchConfig, saveConfig } = useConfigStore();
  const { toast } = useToast();
  
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const handleSave = useCallback(async () => {
    try {
      await saveConfig();
      toast({
        title: "Settings saved. ",
        description: "Clear the cache if you are using any cache plugins.",
        variant: "success",
      });
    } catch {
      toast({
        title: "Failed to save settings. ",
        description: "Please try again.",
        variant: "destructive",
      });
    }
  }, [saveConfig, toast]);
  
  return (
    <>{isLoading ? <CheckerSkeletonLoader /> : <AccessibilityCheckerTab onSave={handleSave} />}</>
  );
}
